/**
 * アプリ設定
 *
 * 現在のアプリIDを管理します。
 * 環境変数 REACT_APP_APP_ID で上書き可能。
 */

export const CURRENT_APP_ID = process.env.REACT_APP_APP_ID || 'chusho-app';

export interface AppMetadata {
  name: string;
  nameEn: string;
  enabled: boolean;
  category: string;
  description: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export const APP_METADATA: AppMetadata = {
  name: '中小企業診断士',
  nameEn: 'Small and Medium Enterprise Management Consultant',
  enabled: true,
  category: 'business',
  description: '中小企業診断士試験の学習支援アプリ'
};
